export default ({ app }, inject) => {
  const formatWithUnit = (value, unitType) => {
    const appConfigs = app.store.getters["config/getConfigs"];
    const appConfig = appConfigs[0];

    // Missing app configuration
    if (!appConfigs || appConfigs.length <= 0) {
      return `${value}N/A`;
    }

    let unit = "";
    // Missing app configuration
    if (!appConfigs || !appConfig) {
      unit = "-";
    }

    if (unitType == "DRINK") {
      unit = appConfig.unit;
    }

    if (unitType == "PACK") {
      unit = appConfig.other_unit;
    }

    if (unitType == "CURRENCY") {
      unit = app.i18n.locale === "en" ? "$" : "đ";
    }

    if (unit === "$") {
      return `${unit}${value}`;
    } else {
      return `${value} ${unit}`;
    }
  };

  inject("formatWithUnit", formatWithUnit); // $formatWithUnit
};
